export enum FeatureToggles {
  NEW_LICENSE_TYPES_ENABLED = 'newLicenseTypesEnabled',
  YOUTUBE_STANDARD_ENABLED = 'youtubeStandardEnabled',
  BRAND_FAN_MEMBERS_ENHANCEMENT_ENABLED = 'brandFanMembersEnhancementEnabled',
  // Kill Switches
  PCR_IG_VIDEOS_ENABLED = 'pcrIGVideosEnabled',
}
